// extracted by mini-css-extract-plugin
module.exports = {"shippingAddress":"RequestNewAddress_shippingAddress__1fAv6","subHeading":"RequestNewAddress_subHeading__1MdcD","Checkbox":"RequestNewAddress_Checkbox__15QDC"};